import { useGetMeQuery } from 'API/BaseApi';
import { useParams } from 'react-router-dom';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import {
  eAccessControlUserType,
  eAccessControlUserUrlTypes,
  mapUrlUserTypeToEnum,
} from 'ui-toolkit/enums/eAccessControlUserType';

export const useGetUserType = (): eAccessControlUserType => {
  const { data } = useGetMeQuery();
  const { userType } = useParams<{ userType: eAccessControlUserUrlTypes }>();
  const pageUserType = mapUrlUserTypeToEnum[userType];
  const permissions = data?.permissions ?? [];
  const permissionUserType = userTypeFromPermissions(permissions);
  // Page User type is more important, as we stop using user type for pages,
  // the permission type taking over will work out long term
  return pageUserType ?? permissionUserType;
};

const userTypeFromPermissions = (permissions: ePermissions[]): eAccessControlUserType => {
  switch (true) {
    case permissions.includes(ePermissions.AdminRead):
      return eAccessControlUserType.Admin;
    case permissions.includes(ePermissions.ReadClientPortal):
      return eAccessControlUserType.Client;
    case permissions.includes(ePermissions.ReadVendorPortal):
      return eAccessControlUserType.Vendor;
    default:
      return eAccessControlUserType.None;
  }
};
